import { useQuery } from '@tanstack/react-query'
import { AxiosRequestConfig } from 'axios'

import axiosInstance from '@/libs/configs/axios'
import isEmailValidator from '@/libs/helpers/is-email-validator'
import { parseIndonesiaPhoneNumber } from '@/libs/helpers/parse-indonesia-phone-number'
import { TApiResult, TQueryInfo } from '@/libs/types/global.types'

export const QUERY_INFO_KEY = 'query_info'

export type TUserQueryInfoResponse = TQueryInfo

export const getQueryInfo = (username: string) => {
  const axiosConfig: AxiosRequestConfig = {
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    url: '/auth/query-info',
    method: 'get',
  }

  let params: { email?: string; phone_number?: string } | undefined = undefined

  if (username) {
    const checkEmailValidation = isEmailValidator(username)

    if (checkEmailValidation) {
      params = { email: username }
    } else {
      params = { phone_number: parseIndonesiaPhoneNumber(username) }
    }
  }

  return axiosInstance<TApiResult<TUserQueryInfoResponse>>({
    ...axiosConfig,
    params,
  })
}

const useSuspenseGetQueryInfo = (username?: string) => {
  return useQuery({
    queryKey: [QUERY_INFO_KEY, username],
    queryFn: ({ queryKey }) => getQueryInfo(queryKey?.[1] || ''),
    enabled: !!username,
  })
}

export default useSuspenseGetQueryInfo
